import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
// import HomeIcon from '@mui/icons-material/Home';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import GroupsIcon from '@mui/icons-material/Groups';
// import SecurityIcon from '@mui/icons-material/Security';
import { useNavigate } from "react-router-dom";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';

function MobileMarketPlaceTab() {
    const navigate = useNavigate()
    const [value, setValue] = React.useState(0);
  return (
    <>
      <div className="mobBottomNavMain">
        <Box>
          <BottomNavigation
            showLabels
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          >
            <BottomNavigationAction label="Buyer" icon={<ShoppingBagIcon />} onClick={()=>navigate('/MobileMarketPlaceBuyer')}/>
            <BottomNavigationAction label="Seller" icon={<ShoppingBagIcon />} onClick={()=>navigate('/MobileMarketPlaceSeller')}/>
          </BottomNavigation>
        </Box>
      </div>
      <div className="mobNavFixedPatch"></div>
    </>
  )
}

export default MobileMarketPlaceTab